export default __webpack_public_path__ + "static/media/closed-ranking-lights.8b4f275b.png";